export default __webpack_public_path__ + "static/media/timerScreenshot-portrait.6a1a0c08.png";